package de.katoonerie.contentful

import de.katoonerie.type.Result
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

sealed interface ContentfulOperations {

    interface GetHomepage : ContentfulOperations {
        suspend fun getHomepage(preview: Boolean = false): Result<Homepage>
    }

    interface GetPage : ContentfulOperations {
        suspend fun getPageByUrl(url: String, preview: Boolean = false): Result<Page?>
    }

    interface GetAsset : ContentfulOperations {
        suspend fun getAsset(id: String, preview: Boolean = false): Result<Asset?>
    }

    @Serializable
    sealed class JsonNode {

        @Serializable
        @SerialName("document")
        data class Document(
            val content: List<Content>
        ) : JsonNode() {
            @Serializable
            sealed interface Content
        }

        @Serializable
        @SerialName("embedded-entry-block")
        data class EmbeddedEntryBlock(
            val data: Data
        ) : JsonNode(), Document.Content

        @Serializable
        @SerialName("embedded-asset-block")
        data class EmbeddedAssetBlock(
            val data: Data
        ) : JsonNode(), Document.Content

        @Serializable
        @SerialName("paragraph")
        data class Paragraph(
            val content: List<Content>
        ) : JsonNode(), Document.Content {
            @Serializable
            sealed interface Content
        }

        @Serializable
        @SerialName("text")
        data class Text(
            val value: String
        ) : JsonNode(), Paragraph.Content

        @Serializable
        @SerialName("hyperlink")
        data class Hyperlink(
            val data: Data,
            val content: List<Text>
        ) : JsonNode(), Paragraph.Content {
            @Serializable
            data class Data(val uri: String)
        }

        @Serializable
        @SerialName("asset-hyperlink")
        data class AssetHyperlink(
            val data: Data,
            val content: List<Text>
        ) : JsonNode(), Paragraph.Content

        @Serializable
        data class Data(
            val target: Target
        ) {
            @Serializable
            data class Target(val sys: Sys)
        }

        @Serializable
        data class Sys(
            val id: String,
            val type: Type,
            val linkType: LinkType
        ) {
            enum class Type { Link }

            enum class LinkType { Entry, Asset }
        }
    }
}
